// extracted by mini-css-extract-plugin
export default {"wrapperForBorder":"JackpotItemDetails_wrapperForBorder--OuC","sizeChange":"JackpotItemDetails_sizeChange--cV0","contentWrapper":"JackpotItemDetails_contentWrapper--dOa"};